import { Pipe, PipeTransform } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { ContentService } from '../../services/content/content.service';
import * as _ from 'lodash';

@Pipe({
  name: 'contentInformation'
})
export class CinemaPipe implements PipeTransform {

  constructor(private cm: ContentService) {
  }

  transform(entry: Models.ContentEntry): Models.CinemaEntry {

    const showTimesByMovieId = {}
    if (entry && entry.detail && entry.detail.showTimes) {
      for (const show of entry.detail.showTimes) {
        if (!showTimesByMovieId[show.movieId]) {
          showTimesByMovieId[show.movieId] = [];
        }
        showTimesByMovieId[show.movieId].push(show);
      }
    }

    const movies: Models.MovieEntry[] = [];
    for (const movieId of Object.keys(showTimesByMovieId)) {
      const movie = this.cm.getEntry(movieId);
      if (!movie) {
        return;
      }
      const showTimes = _.orderBy(showTimesByMovieId[movieId], ['playtime', 'ASC']);
      const shows: Models.PlaytimeEntry[] = [];
      for (const show of showTimes) {
        const playtime = new Models.PlaytimeEntry();
        playtime.populateFromJSON({
          playtime: show.playtime,
          age: show.age,
          language: show.language
        });
        shows.push(playtime);
      }
      let url = null;
      if (movie.detail && movie.detail.urls) {
        for (const urlElement of movie.detail.urls) {
          if (urlElement.title === 'cineman') {
            url = urlElement.url;
          }
        }
      }
      const media = this.cm.getMediaEntriesForEntry(movie.getId());

      if ((!media || !media.length) && movie.files && movie.files.length) {
        const poster = movie.files.find(el => el.group === 'posters');
        if (poster) {
          const posters = this.cm.getFile(poster.id);
          const image = new Models.MediaEntry();
          image.populateFromJSON({
            URL: posters.url,
            type: 'image'
          });
          media.push(image);
        }
        const trailer = movie.files.find(el => el.group === 'trailers');
        if (trailer) {
          const trailers = this.cm.getFile(trailer.id);
          const video = new Models.MediaEntry();
          video.populateFromJSON({
            URL: trailers.url,
            type: 'video'
          });
          media.push(video);
        }
      }
      const movieEntry = new Models.MovieEntry();
      movieEntry.populateFromJSON({
        title: movie.title,
        actors: movie.detail.actors,
        directors: movie.detail.directors,
        age: movie.detail.age,
        awards: movie.detail.awards,
        country: movie.detail.country,
        genre: movie.detail.genres,
        description: movie.detail.plot,
        year: movie.detail.year,
        playtimes: shows,
        sourceId: movie._id,
        url, media
      });
      movies.push(movieEntry);
    }

    const cinema = new Models.CinemaEntry();
    let phone;
    let fax;
    let email;
    if (entry.detail && entry.detail.contact) {
      for (const con of entry.detail.contact) {
        if (con.variants) {
          for (const variant of con.variants) {
            switch (variant.type) {
              case 'phone':
                phone = variant.value;
                break;
              case 'email':
                email = variant.value;
                break;
              case 'fax':
                fax = variant.value;
                break;
            }
          }
        }

      }
    }
    cinema.populateFromJSON({
      title: entry.title,
      street: entry.detail.location ? entry.detail.location.address : '',
      city: entry.detail.location ? entry.detail.location.city : '',
      zip: entry.detail.location ? entry.detail.location.zip : '',
      latitude: entry.detail.location ? entry.detail.location.coordinates.latitude : '',
      longitude: entry.detail.location ? entry.detail.location.coordinates.longitude : '',
      isOpenAir: entry.detail.isOpenAir,
      website: entry.detail.website,
      movies, email, phone, fax
    });
    return cinema;
  }
}
